<template>
  <v-dialog max-width="700px"
            v-model="dialog"
  >
    <v-btn flat slot="activator" dark id="addUser">
       <v-icon >add</v-icon>

      Add user </v-btn>


    <v-card>
              <v-toolbar dark  color="teal lighten-3" class="mb-5">
                <v-toolbar-title>Add new user</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>


               <v-form  ref="form" class=px-3>
                  <v-text-field
                     autofocus
                     prepend-icon="person"
                     name="name"
                     label="Name" 
                     type="text" 
                   
                     v-model="User.Name"
                     :rules="nameRules"
                     >                   
                   </v-text-field>
                
                  <v-text-field
                     
                     prepend-icon="email"
                     name="email"
                     label="Email" 
                     type="text" 
                     
                     v-model="User.Email"
                     :rules="emailRules"

                     >    
                     
                                    
                   </v-text-field>

                 </v-form>
                    <span v-show="errors.has('email')">{{ errors.first('email') }}</span>
                  

                  <v-text-field
                      prepend-icon="lock"
                      name="password"
                      label="Password"
                      id="" 
                      type="password"
                     
                      v-model="User.Password"
                      :rules="passwordrules"
                     class=px-3
                     > 
                  </v-text-field>

                  <v-text-field
                      prepend-icon="lock"
                      name="Confirm_password"
                      label="Confirm Password"
                      id="Confirm_password" 
                      type="password"
                      v-model="User.Confirm_password"
                      :rules=" Confirm_password_Rules"
                      class=px-3
                     > 
                  </v-text-field>
                   <v-spacer />
                  <p  v-show="status" v-text="news" style="text-align: center; color: red;"></p>


                </v-form>

                  </v-card-text>


                 
                   
                  <v-card-actions class=py-5>
                    <v-btn left dark color="teal lighten-3" v-on:click="saveData"  >Register</v-btn>
                   <v-spacer />
                   
                  </v-card-actions>





    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios'

  export default {
    components: {
      
    },

     props:{

        parentFunctioncall:""
     },

     data: () => ({
 /*      password:'',*/
       dialog: false,
       status:false,
       news:'password Doesnt match',
       User:{
         
         Name:'',
         Email:'',
         Password:'',
         Confirm_password:'',

       

       },

       passwordrules: [
          (v) => !!v || 'Password is required',
          (v) => v && v.length >= 5 || 'Password must be more than 5 characters'
        ],

       emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
         
        ] ,
        nameRules:[
          (v) => !!v || 'Name is required',

        ],
        Confirm_password_Rules:[

          (v) => !!v || 'Password required',  
         /* (v) => v != this. || 'E-mail must match'*/
     //     console.log(v),
        /*  (v) => v== this.passwordval || 'Password Doesnt match'*/

        ]
        
    }),

        
        mounted() {
                 
           this.User.Name="",
           this.User.Email="",
           this.User.Password=""


               
     },
    methods:{
          
      saveData(){

              

              this.$refs.form.validate();
              this.Confirm_password_funtion();
              console.log(this.User.Password);
              
         

      if(this.Confirm_password_funtion()==false && this.$refs.form.validate()==true ){

        var xa= '';
        xa = localStorage.getItem("VueToken");
        console.log(xa);

const axiosParams = {
  headers: {
    'Content-Type': 'application/json',
    'Authorization':"Bearer "+xa,
  }
};


    this.loader=true;
       axios.post("http://demosida.net/laravlFinal_extentin/public/api/user/create",{

        name:this.User.Name,
        email:this.User.Email,
        password:this.User.Password


        },axiosParams).then((response) => {

         // console.log(response.data.email);
            
            console.log(response.data);
                this.loader=false;
              this.$swal({
                position: 'bottom-middle',
                type: 'success',
                title: 'Account was created successfully',
                showConfirmButton: false,
                timer: 2000
                }).then(() =>{
                   
                   this.afterRegistation();
               })
          
        //  this.afterRegistation();


        }, (error) => {
             
             
              this.$swal.fire({
              type: 'error',
              title: 'Oops...',
              text: error,

              footer: 'Something went Wrong!'
              })

         })

        }


        },

       
      Confirm_password_funtion () { 
        if(this.User.Password === this.User.Confirm_password) 
          {
            return this.status=false ;
          }

         else{

            return this.status=true;
         } 
     },
        
     afterRegistation(){
            

         //  this.$router.go(0);

              
      

            this.dialog = false;
      
           // this.dialog = false;
            this.parentFunctioncall();
            console.log('succes');
     }
      
    }


  }
</script>

<style>

#addUser{
  background: #80CBC4;
    padding: 8px;
    padding-right: 10px;
    padding-bottom: 10px;
    border-radius: 10px;
    margin-left:20px;

}
</style>